<template>
    <div class="items-rent-row">
        <div class="items-rent-row-td-check">
            <div class="side-by-side">
                <b-form-checkbox v-model="selected" :value="item.id" />
            </div>

        </div>

        <div class="items-rent-row-td-product">
            <div class="items-rent-row-level items-rent-row-level-3">
                <div class="items-rent-row-name">
                    <div class="items-rent-row-name-left">
                        <i class="fa-solid fa-grip-lines items-rent-row-icon-layer"></i>
                        <span @click="edit()" class="items-rent-row-name-text title">
                            {{ item.productFullName }}
                        </span>
                    </div>
                    <div class="items-rent-row-edit-wrap">
                        <ButtonGroupInline title="Opções" :buttons="buttonsOptions" @action="onAction" />
                    </div>
                </div>

                <div class="items-rent-row-description title">
                    <span v-html="item.description"></span>
                </div>
            </div>
        </div>

        <div class="text-center items-rent-row-td-quantity title">
            <div>
                {{ item.quantity }}
                <span v-if="item.unitOfMeasurementName">
                    ({{ item.unitOfMeasurementName }})
                </span>
            </div>
            <BadgeStatusStock :itemRent="item" />
        </div>

        <div class="text-center items-rent-row-td-stock title">
            <div>
                <BadgeAvailabilityStock v-if="item.type != 3 && item.type != 4" :itemRent="item"
                    :available="item.available" />
            </div>
        </div>

        <div v-if="!operational" class="text-center items-rent-row-td-price title">
            <BadgeStatusInvoice v-if="!operational" :rent="rent" :itemRent="item" /><br />
            <BadgeTotalization :itemRent="item" />
        </div>

        <div v-if="showKitOrAccessory" class="text-center items-rent-row-td-access accessory-wrap">
            <div v-if="!operational && !item.isAccessory && !item.onlyStock">
                <button v-if="item.type != 2 && item.type != 3 && item.type != 4" class="accessory-btn"
                    title="Acessórios" @click.stop="onAccessoryClick(item)">
                    <span class="items-rent-row-title-accessory">
                        {{ item.totalAccessory }}
                        <span v-if="item.totalAccessory > 1">acessórios</span>
                        <span v-else>acessório</span>
                    </span>
                </button>

                <button v-else-if="item.type == 4" class="accessory-btn" title="Kits" @click.stop="onKitClick(item)">
                    <span class="items-rent-row-title-accessory">
                        {{ item.totalKit }}
                        <span v-if="item.totalKit > 1">produtos</span>
                        <span v-else>produto</span>
                    </span>
                </button>

                <div class="items-empty" v-else></div>
            </div>

            <IconTypeEquipament v-else :itemRent="item" />
        </div>
    </div>
</template>

<script>
import ButtonGroupInline from "@nixweb/nixloc-ui/src/component/forms/ButtonGroupInline";
import BadgeStatusStock from "./BadgeStatusStock.vue";
import BadgeAvailabilityStock from "./BadgeAvailabilityStock.vue";
import BadgeStatusInvoice from "./BadgeStatusInvoice.vue";
import BadgeTotalization from "./BadgeTotalization.vue";
import IconTypeEquipament from "./IconTypeEquipament.vue";
import { mapState, mapMutations } from "vuex";

export default {
    name: "ItemsRentRow",
    components: {
        ButtonGroupInline,
        BadgeStatusStock,
        BadgeAvailabilityStock,
        BadgeStatusInvoice,
        BadgeTotalization,
        IconTypeEquipament
    },
    props: {
        rent: { type: Object, required: false },
        item: { type: Object, required: true },
        totalRecords: { type: Number, required: true },
        operational: { type: Boolean, default: false },
        showKitOrAccessory: { type: Boolean, default: true },
    },
    computed: {
        ...mapState("generic", ["selected"]),
        selected: {
            get() {
                return this.$store.state.generic.selected;
            },
            set(value) {
                this.addSelected(value);
            }
        },
        buttonsOptions() {
            const operational = this.operational ? "operational" : "rental";

            return [
                { id: 'edit', eventName: 'itemRentUpdate', showModule: ["rental", "operational"], eventData: this.item, title: 'Editar', icon: 'fa-solid fa-pen-to-square', color: '#939394' },
                { id: 'discount', eventName: 'applyDiscount', showModule: ["rental"], eventData: this.item, title: 'Aplicar Desconto', icon: 'fa-solid fa-percent', color: '#FF4843' },
                { id: 'group', eventName: 'changeGroup', showModule: ["rental", "operational"], eventData: this.item, title: 'Trocar Grupo', icon: 'fa-solid fa-layer-group', color: '#2563EB' },
                { id: 'delete', eventName: 'itemRentDelete', showModule: ["rental", "operational"], eventData: this.item, title: 'Deletar', icon: 'fa-solid fa-trash', color: '#EF4444' }
            ].filter(a => a.showModule.includes(operational));
        }
    },
    methods: {
        ...mapMutations("generic", ["addEvent", "addSelected"]),
        onAction(actionId) {
            this.$emit("action", { id: actionId, itemId: this.item.id });
        },
        onAccessoryClick() {
            this.addEvent({ name: "itemsAccessoryList", data: this.item });
        },
        onKitClick() {
            this.addEvent({ name: "itemsKitList", data: this.item });
        },
        edit() {
            this.addEvent({ name: "itemRentUpdate", data: this.item });
        }
    }
};
</script>

<style scoped>
.items-rent-row {
    display: grid;
    grid-template-columns: 28px minmax(200px, 1fr) 130px 150px 380px 150px;
    align-items: center;
    border-bottom: 1px solid #eef2f7;
}

.items-rent-row>div {
    padding: 7px 10px 5px 10px;
    box-sizing: border-box;
}

.items-rent-row-td-check {
    margin-left: 20px;
    margin-top: -30px;
}

.items-rent-row-td-product {
    min-width: 0;
    margin-left: 20px;
}

.items-rent-row-td-quantity,
.items-rent-row-td-stock,
.items-rent-row-td-invoice,
.items-rent-row-td-price,
.items-rent-row-td-access {
    white-space: nowrap;
}

.items-rent-row:nth-child(even) {
    background: #fcfcfd;
}

.items-rent-row:hover {
    background: #f9fbff;
}

.items-rent-row-icon-layer {
    color: #9ca3af;
    cursor: grab;
}

.items-rent-row-name {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    column-gap: 10px;
    cursor: pointer;
}

.items-rent-row-name-left {
    min-width: 0;
}

.items-rent-row-name-text {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.items-rent-row-description {
    color: grey;
    font-size: 13px;
    margin-left: 0px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.accessory-btn {
    display: inline-grid;
    place-items: center;
    width: 130px;
    margin-right: 30px;
    padding-left: 10px;
    padding-right: 10px;
    height: 32px;
    border-radius: 20px;
    gap: 5px;
    border: 1px solid #e5e7eb;
    background: #f3f6fa;
    cursor: pointer;
    transition: transform 0.12s ease, background 0.12s ease, border-color 0.12s ease;
}

.items-empty {
    width: 100px;
}

.items-rent-row-level {
    cursor: pointer;
}

.items-rent-row-title-accessory {
    color: #737883;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.8px;
}

.accessory-btn i {
    font-size: 13px;
    color: #6b7280;
}

.accessory-count {
    font-weight: 600;
    font-size: 13px;
    color: #6b7280;
}
</style>
